export default "__VITE_ASSET__a2a1fb55__"